export default __webpack_public_path__ + "static/media/discord.1a0c3dc4.svg";